import getApi from '../../api/apisauceConfig'
import { AudiometerInstance } from '../../model/Audiometry'

export const createAudiometerTemplate = (documentTemplateId: number) =>
  getApi().post<AudiometerInstance>('/audiometry/audiometer_templates', { documentTemplateId })
